'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import AdWordsTextAdReportingRecord from 'AdsUI/records/reporting/AdWordsTextAdReportingRecord';

const Headline = ({
  entity
}) => {
  if (!entity.fullHeadline()) {
    return null;
  }

  return /*#__PURE__*/_jsx("a", {
    className: "external-link post-icon",
    href: entity.finalUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    "data-test-id": "headline-preview",
    children: entity.fullHeadline()
  });
};

const Description = ({
  entity
}) => {
  if (!entity.fullDescription()) {
    return null;
  }

  return /*#__PURE__*/_jsx("div", {
    className: "ad-copy",
    "data-test-id": "preview-description",
    children: entity.fullDescription()
  });
};

const AdWordsTextAdPreview = ({
  entity
}) => /*#__PURE__*/_jsxs("div", {
  className: "adwords-ad-preview",
  children: [/*#__PURE__*/_jsx("div", {
    className: "ad-url",
    children: /*#__PURE__*/_jsx(Headline, {
      entity: entity
    })
  }), /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx("div", {
      className: "display-inline-block adwords-ad-badge",
      children: "Ad"
    }), /*#__PURE__*/_jsx("span", {
      "data-test-id": "preview-url",
      children: entity.getDisplayUrl()
    })]
  }), /*#__PURE__*/_jsx(Description, {
    entity: entity
  })]
});

AdWordsTextAdPreview.propTypes = {
  entity: PropTypes.instanceOf(AdWordsTextAdReportingRecord).isRequired
};
export default AdWordsTextAdPreview;